const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export const normalizeUsPhone = (value) => {
  const raw = (value || "").trim();
  if (!raw || /[^\d\s().+-]/.test(raw)) return null;
  if (raw.includes("+") && (!raw.startsWith("+1") || raw.lastIndexOf("+") > 0)) return null;
  let digits = raw.replace(/\D/g, "");
  if (digits.length === 11 && digits.startsWith("1")) digits = digits.slice(1);
  return digits.length === 10 ? digits : null;
};

export const validateRegistration = ({ first_name, email, phone }) => {
  const errors = {};
  if (!first_name.trim()) errors.first_name = "Please enter your first name.";
  if (!EMAIL_RE.test(email.trim())) errors.email = "Please enter a valid email address.";
  if (!normalizeUsPhone(phone)) errors.phone = "Please enter a valid 10-digit US mobile number.";
  return errors;
};

export const validateApplicationContact = ({ full_name, email, phone }) => {
  const { first_name, ...rest } = validateRegistration({ first_name: full_name, email, phone });
  return first_name ? { full_name: "Please enter your full name.", ...rest } : rest;
};

export const validateContact = ({ full_name, email, phone, message }) => {
  const errors = {};
  if (!full_name.trim()) errors.full_name = "Please enter your name.";
  if (!EMAIL_RE.test(email.trim())) errors.email = "Please enter a valid email.";
  if (phone.trim() && !normalizeUsPhone(phone)) errors.phone = "Please enter a 10-digit US mobile number.";
  if (message.trim().length < 10) errors.message = "Please enter a message (at least 10 characters).";
  return errors;
};
